export default class DxfParserOptions {
    encoding: string = 'utf-8';

    encodingFailureFatal: boolean = false;
}
